// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { HTMLDivProps, Text } from "@blueprintjs/core";
import { GeoMap } from "src/controllers/alerts/components";

import { DuoButtons, ToolBar } from 'src/components';

import { Alignment } from "src/mpd-library";

import "./styles.css";

export interface IncidentLocationProps extends HTMLDivProps {
  incidentLocation: any;
  onMarkerComplete(event: any, marker: any): void;
  onCancelClick(event: any): void;
  onSaveClick(event: any): void;
}

export const IncidentLocation: React.SFC<IncidentLocationProps> = props => {
  const {
    className,
    onCancelClick,
    onMarkerComplete,
    incidentLocation,
    onSaveClick
  } = props;

  const classes = classNames("incident-location-container", className);

  const leftElement = <Text> Add Incident Location </Text>;

  const rightElement = (
    <React.Fragment>
      <DuoButtons
        firstButtonText="cancel"
        secondButtonText="save"
        firstButtonClick={onCancelClick}
        secondButtonClick={onSaveClick}
      />
    </React.Fragment>
  );

  return (
    <div className={classes}>
      <ToolBar
        className="header"
        leftElement={leftElement}
        rightElement={rightElement}
      />
      <div className="map-container">
        <GeoMap
          boxClass="marker-map-info-box"
          onMarkerComplete={onMarkerComplete}
          center={incidentLocation.center}
          drawingMode={"marker"}
          currentMarker={incidentLocation.marker}
          gpsAlignment={Alignment.RIGHT}
          hideDrawControls={true}
          hideList={true}
          style={{
            height: `100%`
          }}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/alert-details/incident-location.tsx